<div class="option" [class.selected]="isSelected" (click)="onClick()">
  {{ displayText }}
</div>
